import { Flex } from 'antd';
import styles from './check-email.module.scss';
import { Button } from '../button/button';
import Icon from '@ant-design/icons';
import Mail from '@/assets/icons/mail-01.svg?react';

import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { calculateSecondsToMinutes, countSeconds } from '@/utils/helpers';
import { START_TIME } from './check-email.constant';

interface CheckEmailProps {
  email: string;
  onResendEmail: () => void;
  showEmailInput: () => void;
}

export function CheckEmail({ email, onResendEmail, showEmailInput }: CheckEmailProps) {
  const { t } = useTranslation('auth');
  const [time, setTime] = useState(START_TIME);
  const disableResending = time !== 0;
  const enableResending = time === START_TIME;

  useEffect(() => {
    countSeconds(setTime, time);
  }, [enableResending]);

  return (
    <Flex className={styles.container} vertical gap={24} align="center" justify="center">
      <Flex className={styles.iconContainer} align="center" justify="center">
        <Icon
          className={styles.mail}
          component={() => <Mail width={24} height={24} stroke={styles.iconColor} />}
        />
      </Flex>
      <h3 className={styles.title}>{t('checkEmail.title')}</h3>
      <p className={styles.paragraph}>
        <Trans
          ns="auth"
          i18nKey="checkEmail.instructions"
          values={{ email }}
          components={{ bold: <span className={styles.bold} /> }}
        />
      </p>
      <Button
        onClick={() => {
          onResendEmail();
          setTime(START_TIME);
        }}
        disabled={disableResending}
        className={styles.button}
      >
        {disableResending
          ? t('checkEmail.resendIn', { time: calculateSecondsToMinutes(time) })
          : t('checkEmail.resend')}
      </Button>
      <p className={styles.paragraph}>
        {t('checkEmail.wrongEmail', { email })}{' '}
        <Button buttonVariant="tertiary" className={styles.changeEmailButton} onClick={showEmailInput}>
          {t('checkEmail.changeEmail')}
        </Button>
      </p>
    </Flex>
  );
}
